import {
  BOGGLE_RUN_SUMMARY_TIER_CATEGORIES,
  getRunSummaryTierLevel,
} from '~/boggle/config/runSummaryScore'

import type { BoggleBadgeCheck } from '../checkTypes'
import { isRunEndEntry } from '../checkTypes'

export const sorcererCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  if (!isRunEndEntry(entry)) {
    return false
  }

  return BOGGLE_RUN_SUMMARY_TIER_CATEGORIES.every(
    category => getRunSummaryTierLevel(category.id, entry.acceptedWords) === 'V',
  )
}
